/**
 * @file 学習者 (お子さんと養育者) の切り替え。
 *
 * @what: family の学習者候補 (learnersOf: active な child と養育者) を丸いタブで並べ、
 *   選択中を aria-pressed で示す。
 * @why: 記録は学習者単位なので、だれの記録かをその場で選べるようにする。1 人でも同じ
 *   見た目にして、複数になったときに UI が変わらないようにする。
 *   面ごとのまなぶ人はヘッダー (LearnerSwitcher) が持つので、ここで使うのは記録シートの
 *   ように、ヘッダーへ届かない場所で相手を選ぶときに限る。
 * @failure: 描画のみ (状態は親が持つ)。learners が空なら何も出さない (空状態の案内は呼び出し側)。
 */

import { memberLabel, type FamilyMember } from "../api/members";
import "./study.css";

export function LearnerTabs({
  learners,
  selectedId,
  onSelect,
}: {
  learners: FamilyMember[];
  selectedId: string | null;
  onSelect: (personId: string) => void;
}) {
  return (
    <div className="study-learners" role="group" aria-label="まなぶ人を選ぶ">
      {learners.map((l) => (
        <button
          key={l.person_id}
          type="button"
          className="study-learner-tab"
          aria-pressed={l.person_id === selectedId}
          onClick={() => onSelect(l.person_id)}
        >
          {memberLabel(l)}
        </button>
      ))}
    </div>
  );
}
